import { Component } from '@theme/component';

class NaptonEliteFinder extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    this.addEventListener('change', this.updateScope, { signal: this.abort.signal });
    this.addEventListener('submit', this.submitSearch, { signal: this.abort.signal });
    this.addEventListener('formdata', this.formatSearch, { signal: this.abort.signal });
    const now = new Date();
    const minimum = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
    const date = this.querySelector('[name="start_date"]');
    if (date instanceof HTMLInputElement) date.min = minimum;
    this.updateScope();
  }

  disconnectedCallback() {
    this.abort?.abort();
    super.disconnectedCallback();
  }

  updatedCallback() {
    super.updatedCallback();
    this.updateScope();
  }

  updateScope = () => {
    const checkbox = this.querySelector('[name="include_elite"]');
    const submit = this.querySelector('[data-finder-submit]');
    const note = this.querySelector('[data-finder-note]');
    const guests = this.querySelector('[name="num_persons"]');
    if (!(checkbox instanceof HTMLInputElement)) return;
    if (submit) submit.textContent = checkbox.checked ? this.dataset.searchLabel : this.dataset.enquiryLabel;
    if (note) note.textContent = checkbox.checked ? this.dataset.searchNote : this.dataset.enquiryNote;
    if (guests instanceof HTMLInputElement) {
      guests.min = checkbox.checked ? '2' : '1';
      guests.max = checkbox.checked ? '10' : this.dataset.capacity;
      guests.value = String(Math.max(Number(guests.min), Math.min(Number(guests.value) || Number(guests.min), Number(guests.max))));
    }
  };

  bookingDestination() {
    if (!this.dataset.bookingUrl) return null;
    let url;
    try {
      url = new URL(this.dataset.bookingUrl, window.location.origin);
    } catch {
      return null;
    }
    if (!['https:', 'http:'].includes(url.protocol)) return null;
    const date = this.querySelector('[name="start_date"]')?.value;
    if (date && this.dataset.dateParameter) {
      const [year, month, day] = date.split('-');
      url.searchParams.set(this.dataset.dateParameter, this.dataset.dateFormat === 'uk' ? [day, month, year].join('/') : date);
    }
    const duration = this.querySelector('[name="duration"]')?.value;
    if (duration && this.dataset.durationParameter) url.searchParams.set(this.dataset.durationParameter, duration);
    const guests = this.querySelector('[name="num_persons"]')?.value;
    if (guests && this.dataset.guestsParameter) url.searchParams.set(this.dataset.guestsParameter, guests);
    return url.href;
  }

  submitSearch = (event) => {
    const checkbox = this.querySelector('[name="include_elite"]');
    if (!(checkbox instanceof HTMLInputElement)) return;
    if (checkbox.checked) {
      const form = event.target;
      if (form instanceof HTMLFormElement) {
        form.action = 'https://www.napton-marina.co.uk/availability/search_results.php#search_results';
        form.method = 'post';
      }
      return;
    }
    event.preventDefault();
    const destination = this.bookingDestination();
    if (destination) {
      window.location.assign(destination);
      return;
    }
    const enquiry = document.getElementById(this.dataset.enquiryId);
    if (!(enquiry instanceof HTMLElement)) return;
    const date = enquiry.querySelector('[name="contact[Preferred departure]"]');
    const guests = enquiry.querySelector('[name="contact[Party size]"]');
    const duration = enquiry.querySelector('[name="contact[Holiday length]"]');
    const picker = this.querySelector('[name="duration"]');
    const selectedDate = this.querySelector('[name="start_date"]');
    const selectedGuests = this.querySelector('[name="num_persons"]');
    if (date instanceof HTMLInputElement && selectedDate instanceof HTMLInputElement) date.value = selectedDate.value;
    if (guests instanceof HTMLInputElement && selectedGuests instanceof HTMLInputElement) guests.value = selectedGuests.value;
    if (duration instanceof HTMLSelectElement && picker instanceof HTMLSelectElement) duration.value = picker.selectedOptions[0].textContent;
    enquiry.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    enquiry.querySelector('[name="contact[name]"]')?.focus({ preventScroll: true });
  };

  formatSearch = (event) => {
    if (!this.querySelector('[name="include_elite"]')?.checked) return;
    const date = event.formData.get('start_date');
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, day] = date.split('-');
      event.formData.set('start_date', [day, month, year].join('/'));
    }
    event.formData.delete('include_elite');
  };
}
if (!customElements.get('napton-elite-finder')) customElements.define('napton-elite-finder', NaptonEliteFinder);

